import { render, staticRenderFns } from "./HeaderSwiper.vue?vue&type=template&id=27444fcb&scoped=true"
import script from "./HeaderSwiper.vue?vue&type=script&lang=js"
export * from "./HeaderSwiper.vue?vue&type=script&lang=js"
import style0 from "./HeaderSwiper.vue?vue&type=style&index=0&id=27444fcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27444fcb",
  null
  
)

export default component.exports